import React from 'react';
import PhysicalInventoryPage from './PhysicalInventoryPage';

const Stock: React.FC = () => {
  return <PhysicalInventoryPage />;
};

export default Stock;
